import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class FarmerModel {
    farmerId: number;
    constructor(farmerId:number){
        this.farmerId = farmerId;
    }
}